module.exports = __webpack_public_path__ + "img/desaparecidos.26f8b92a.jpg";